module.exports = __webpack_public_path__ + "assets/img/member-bj.784a79dc.png";